import React from 'react';

const LogoHMenuOpen = () => {
	return (
		<div className="main-header-div-top">
			<div className="small-title-div">
				<h1 className="title-small">tamar</h1>
				<div className="outer-circle-small">
					<div className="circle"></div>
				</div>
				<h1 className="title-small">dev</h1>
			</div>
		</div>
	);
};

export default LogoHMenuOpen;
